import { useState } from "react";
import useLocationEventListener from "./useLocationEventListener";

const useDeliveryTypeChangeListener = ({
    onDeliveryTypeChangeCb = () => null,
    onLocationChangeCb = () => null,
}) => {
    const [currentCookie, setCurrentCookie] = useState(window.cookie.get());

    useLocationEventListener((evt) => {
        const newCookie = evt.detail;
        const isSameDeliveryType =
            currentCookie.area.type === newCookie.area.type;
        const isSameStore =
            currentCookie.area.store_id === newCookie.area.store_id;

        if (!isSameDeliveryType) {
            onDeliveryTypeChangeCb();
        }

        if (!isSameStore) {
            onLocationChangeCb();
        }

        setCurrentCookie(window.cookie.get());
    });
};

export default useDeliveryTypeChangeListener;
